(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined'
    ? factory(exports)
    : typeof define === 'function' && define.amd
    ? define(['exports'], factory)
    : ((global =
        typeof globalThis !== 'undefined' ? globalThis : global || self),
      factory((global.dynamicMarquee = {})));
})(this, function (exports) {
  'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError('Cannot call a class as a function');
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ('value' in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  var DIRECTION = {
    RIGHT: 'right',
    DOWN: 'down',
  };

  function size($el, direction) {
    return $el[direction === DIRECTION.RIGHT ? 'offsetWidth' : 'offsetHeight'];
  }
  function defer(fn) {
    window.setTimeout(function () {
      return fn();
    }, 0);
  }
  function deferException(cb) {
    try {
      return cb();
    } catch (e) {
      defer(function () {
        throw e;
      });
    }
  }
  function toDomEl($el) {
    if (typeof $el === 'string' || typeof $el === 'number') {
      // helper. convert string to div
      var $div = document.createElement('div');
      $div.textContent = $el + '';
      return $div;
    }

    return $el;
  }

  var transitionDuration = 60000;
  var Item = /*#__PURE__*/ (function () {
    function Item($el, direction) {
      _classCallCheck(this, Item);

      var $container = document.createElement('div');
      $container.style.display = 'block';
      $container.style.position = 'absolute';
      $container.style.margin = '0';
      $container.style.padding = '0';

      if (direction === DIRECTION.RIGHT) {
        $container.style.whiteSpace = 'nowrap';
      }

      $container.style.willChange = 'auto';
      $container.appendChild($el);
      this._$container = $container;
      this._$el = $el;
      this._direction = direction;
      this._transitionState = null;
    }

    _createClass(Item, [
      {
        key: 'getSize',
        value: function getSize() {
          var _ref =
              arguments.length > 0 && arguments[0] !== undefined
                ? arguments[0]
                : {},
            _ref$inverse = _ref.inverse,
            inverse = _ref$inverse === void 0 ? false : _ref$inverse;

          var dir = this._direction;

          if (inverse) {
            dir = dir === DIRECTION.RIGHT ? DIRECTION.DOWN : DIRECTION.RIGHT;
          }

          return size(this._$container, dir);
        },
      },
      {
        key: 'setOffset',
        value: function setOffset(offset, rate, force) {
          var transitionState = this._transitionState;
          var rateChanged = !transitionState || transitionState.rate !== rate;

          if (transitionState && !force) {
            var timePassed = performance.now() - transitionState.time;

            if (timePassed < transitionDuration - 10000 && !rateChanged) {
              return;
            }
          }

          if (force || rateChanged) {
            if (this._direction === DIRECTION.RIGHT) {
              this._$container.style.transform = 'translateX('.concat(
                offset,
                'px)'
              );
            } else {
              this._$container.style.transform = 'translateY('.concat(
                offset,
                'px)'
              );
            }

            this._$container.style.transition = '';
            this._$container.offsetLeft;
          }

          var futureOffset = offset + (rate / 1000) * transitionDuration;

          if (this._direction === DIRECTION.RIGHT) {
            this._$container.style.transform = 'translateX('.concat(
              futureOffset,
              'px)'
            );
          } else {
            this._$container.style.transform = 'translateY('.concat(
              futureOffset,
              'px)'
            );
          }

          if (rate) {
            this._$container.style.transition = 'transform '.concat(
              transitionDuration,
              'ms linear'
            );
          }

          this._transitionState = {
            time: performance.now(),
            rate: rate,
          };
        },
      },
      {
        key: 'enableAnimationHint',
        value: function enableAnimationHint(enable) {
          this._$container.style.willChange = enable ? 'transform' : 'auto';
        },
      },
      {
        key: 'remove',
        value: function remove() {
          this._$container.remove();
        },
      },
      {
        key: 'getContainer',
        value: function getContainer() {
          return this._$container;
        },
      },
      {
        key: 'getOriginalEl',
        value: function getOriginalEl() {
          return this._$el;
        },
      },
    ]);

    return Item;
  })();
  var VirtualItem = /*#__PURE__*/ (function () {
    function VirtualItem(size) {
      _classCallCheck(this, VirtualItem);

      this._size = size;
    }

    _createClass(VirtualItem, [
      {
        key: 'getSize',
        value: function getSize() {
          var _ref2 =
              arguments.length > 0 && arguments[0] !== undefined
                ? arguments[0]
                : {},
            _ref2$inverse = _ref2.inverse,
            inverse = _ref2$inverse === void 0 ? false : _ref2$inverse;

          if (inverse) {
            throw new Error('Inverse not supported on virtual item.');
          }

          return this._size;
        },
      },
      {
        key: 'setOffset',
        value: function setOffset() {},
      },
      {
        key: 'enableAnimationHint',
        value: function enableAnimationHint() {},
      },
      {
        key: 'remove',
        value: function remove() {},
      },
    ]);

    return VirtualItem;
  })();

  var Marquee = /*#__PURE__*/ (function () {
    function Marquee($container) {
      var _ref =
          arguments.length > 1 && arguments[1] !== undefined
            ? arguments[1]
            : {},
        _ref$rate = _ref.rate,
        rate = _ref$rate === void 0 ? -25 : _ref$rate,
        _ref$upDown = _ref.upDown,
        upDown = _ref$upDown === void 0 ? false : _ref$upDown,
        _ref$startOnScreen = _ref.startOnScreen,
        startOnScreen =
          _ref$startOnScreen === void 0 ? false : _ref$startOnScreen;

      _classCallCheck(this, Marquee);

      this._rendering = false;
      this._waitingForItem = true;
      this._nextItemImmediatelyFollowsPrevious = startOnScreen;
      this._rate = rate;
      this._lastEffectiveRate = rate;
      this._justReversedRate = false;
      this._windowWidth = window.innerWidth;
      this._windowHeight = window.innerHeight;
      this._direction = upDown ? DIRECTION.DOWN : DIRECTION.RIGHT;
      this._onItemRequired = [];
      this._onItemRemoved = [];
      this._onAllItemsRemoved = [];
      this._leftItemOffset = 0;
      this._containerSize = 0;
      this._items = [];
      this._pendingItem = null;
      var $innerContainer = document.createElement('div');
      $innerContainer.style.position = 'relative';
      $innerContainer.style.display = 'inline-block';
      this._$container = $innerContainer;
      this._containerInverseSize = null;
      $innerContainer.style.width = '100%';

      if (this._direction === DIRECTION.DOWN) {
        $innerContainer.style.height = '100%';
      }

      this._updateContainerInverseSize();

      $container.appendChild($innerContainer);

      this._scheduleRender();
    } // called when there's room for a new item.
    // You can return the item to append next

    _createClass(Marquee, [
      {
        key: 'onItemRequired',
        value: function onItemRequired(cb) {
          this._onItemRequired.push(cb);
        }, // Called when an item is removed
      },
      {
        key: 'onItemRemoved',
        value: function onItemRemoved(cb) {
          this._onItemRemoved.push(cb);
        }, // Called when the last item is removed
      },
      {
        key: 'onAllItemsRemoved',
        value: function onAllItemsRemoved(cb) {
          this._onAllItemsRemoved.push(cb);
        },
      },
      {
        key: 'getNumItems',
        value: function getNumItems() {
          return this._items.filter(function (_ref2) {
            var item = _ref2.item;
            return item instanceof Item;
          }).length;
        },
      },
      {
        key: 'setRate',
        value: function setRate(rate) {
          if (rate === this._rate) {
            return;
          }

          if (!rate !== !this._rate) {
            this._enableAnimationHint(!!rate);

            if (rate) {
              this._scheduleRender();
            }
          }

          if (rate * this._lastEffectiveRate < 0) {
            this._justReversedRate = !this._justReversedRate;

            if (rate <= 0) {
              var containerSize = this._containerSize;
              var nextOffset = this._leftItemOffset;

              this._items.forEach(function (_ref3) {
                var item = _ref3.item;
                nextOffset += item.getSize();
              });

              this._waitingForItem = nextOffset <= containerSize;
            } else {
              this._waitingForItem = this._leftItemOffset >= 0;
            }
          }

          this._rate = rate;

          if (rate) {
            this._lastEffectiveRate = rate;
          }
        },
      },
      {
        key: 'getRate',
        value: function getRate() {
          return this._rate;
        },
      },
      {
        key: 'clear',
        value: function clear() {
          var _this = this;

          this._items.forEach(function (_ref4) {
            var item = _ref4.item;
            return _this._removeItem(item);
          });

          this._items = [];
          this._waitingForItem = true;

          this._updateContainerInverseSize();
        },
      },
      {
        key: 'isWaitingForItem',
        value: function isWaitingForItem() {
          return this._waitingForItem;
        },
      },
      {
        key: 'appendItem',
        value: function appendItem($el) {
          if (!this._waitingForItem) {
            throw new Error('No room for item.');
          } // convert to div if $el is a string

          $el = toDomEl($el);

          var itemAlreadyExists = this._items.some(function (_ref5) {
            var item = _ref5.item;
            return item instanceof Item && item.getOriginalEl() === $el;
          });

          if (itemAlreadyExists) {
            throw new Error('Item already exists.');
          }

          this._waitingForItem = false;
          this._pendingItem = new Item($el, this._direction);

          this._pendingItem.enableAnimationHint(!!this._rate);

          if (this._rendering) {
            this._render(0);
          } else {
            this._scheduleRender();
          }
        },
      },
      {
        key: '_removeItem',
        value: function _removeItem(_ref6) {
          var _this2 = this;

          var item = _ref6.item;
          defer(function () {
            item.remove();

            if (item instanceof Item) {
              _this2._onItemRemoved.forEach(function (cb) {
                deferException(function () {
                  return cb(item.getOriginalEl());
                });
              });
            }
          });
        }, // update size of container so that the marquee items fit inside it.
        // This is needed because the items are posisitioned absolutely, so not in normal flow.
        // Without this, for DIRECTION.RIGHT, the height of the container would always be 0px, which is not useful
      },
      {
        key: '_updateContainerInverseSize',
        value: function _updateContainerInverseSize() {
          if (this._direction === DIRECTION.DOWN) {
            return;
          }

          var maxSize = this._items.reduce(function (size, _ref7) {
            var item = _ref7.item;

            if (item instanceof VirtualItem) {
              return size;
            }

            var a = item.getSize({
              inverse: true,
            });

            if (a > size) {
              return a;
            }

            return size;
          }, 0);

          if (this._containerInverseSize !== maxSize) {
            this._containerInverseSize = maxSize;
            this._$container.style.height = ''.concat(maxSize, 'px');
          }
        },
      },
      {
        key: '_enableAnimationHint',
        value: function _enableAnimationHint(enable) {
          this._items.forEach(function (_ref8) {
            var item = _ref8.item;
            return item.enableAnimationHint(enable);
          });
        },
      },
      {
        key: '_scheduleRender',
        value: function _scheduleRender() {
          var _this3 = this;

          if (!this._requestAnimationID) {
            this._lastUpdateTime = performance.now();
            this._requestAnimationID = window.requestAnimationFrame(
              function () {
                return _this3._onRequestAnimationFrame();
              }
            );
          }
        },
      },
      {
        key: '_onRequestAnimationFrame',
        value: function _onRequestAnimationFrame() {
          var _this4 = this;

          this._requestAnimationID = null;

          if (!this._items.length && !this._pendingItem) {
            return;
          }

          var now = performance.now();
          var timePassed = now - this._lastUpdateTime;

          if (this._rate) {
            this._scheduleRender();
          }

          this._rendering = true;
          var shiftAmount = this._rate * (timePassed / 1000);
          this._containerSize = size(this._$container, this._direction);
          deferException(function () {
            return _this4._render(shiftAmount);
          });
          this._rendering = false;
        },
      },
      {
        key: '_render',
        value: function _render(shiftAmount) {
          var _this5 = this;

          this._leftItemOffset += shiftAmount;
          var containerSize = this._containerSize;

          if (this._rate < 0) {
            while (this._items.length) {
              var item = this._items[0].item;

              var _size = item.getSize();

              if (this._leftItemOffset + _size > 0) {
                break;
              }

              this._removeItem(this._items[0]);

              this._items.shift();

              this._leftItemOffset += _size;
            }
          }

          var offsets = [];
          var nextOffset = this._leftItemOffset;

          this._items.some(function (_ref9, i) {
            var item = _ref9.item;

            if (nextOffset >= containerSize) {
              if (_this5._rate > 0) {
                _this5._items.splice(i).forEach(function (a) {
                  return _this5._removeItem(a);
                });

                return true;
              }
            }

            offsets.push(nextOffset);
            nextOffset += item.getSize();
            return false;
          });

          var justReversedRate = this._justReversedRate;
          this._justReversedRate = false;

          if (justReversedRate) {
            this._nextItemImmediatelyFollowsPrevious = false;
          }

          if (this._pendingItem) {
            this._$container.appendChild(this._pendingItem.getContainer());

            if (this._rate <= 0) {
              if (!this._nextItemImmediatelyFollowsPrevious) {
                // insert virtual item so that it starts off screen
                this._items.push({
                  item: new VirtualItem(
                    Math.max(0, containerSize - nextOffset)
                  ),
                  offset: nextOffset,
                });

                offsets.push(nextOffset);
                nextOffset = containerSize;
              }

              this._items.push({
                item: this._pendingItem,
                offset: nextOffset,
              });

              offsets.push(nextOffset);
              nextOffset += this._pendingItem.getSize();
            } else {
              if (
                this._nextItemImmediatelyFollowsPrevious &&
                !this._items.length
              ) {
                this._leftItemOffset = containerSize;
              } else if (
                !this._nextItemImmediatelyFollowsPrevious &&
                this._items.length &&
                this._leftItemOffset > 0
              ) {
                this._items.unshift({
                  item: new VirtualItem(this._leftItemOffset),
                  offset: 0,
                });

                offsets.unshift(0);
                this._leftItemOffset = 0;
              }

              this._leftItemOffset -= this._pendingItem.getSize();
              offsets.unshift(this._leftItemOffset);

              this._items.unshift({
                item: this._pendingItem,
                offset: this._leftItemOffset,
              });
            }

            this._pendingItem = null;
          } // trim virtual items

          while (
            this._items.length &&
            this._items[0].item instanceof VirtualItem
          ) {
            offsets.shift();

            this._items.shift();

            this._leftItemOffset = offsets[0] || 0;
          }

          while (
            this._items.length &&
            this._items[this._items.length - 1].item instanceof VirtualItem
          ) {
            offsets.pop();

            this._items.pop();
          }

          var windowWidth = window.innerWidth;
          var windowHeight = window.innerHeight;
          var windowResized =
            windowWidth !== this._windowWidth ||
            windowHeight !== this._windowHeight;
          this._windowWidth = windowWidth;
          this._windowHeight = windowHeight;
          offsets.forEach(function (offset, i) {
            var item = _this5._items[i];
            var hasJumped = Math.abs(item.offset + shiftAmount - offset) >= 1;
            item.item.setOffset(
              offset,
              _this5._rate,
              windowResized || hasJumped
            );
            item.offset = offset;
          });

          this._updateContainerInverseSize();

          if (!this._items.length) {
            this._leftItemOffset = 0;
            defer(function () {
              _this5._onAllItemsRemoved.forEach(function (cb) {
                deferException(function () {
                  return cb();
                });
              });
            });
          }

          this._nextItemImmediatelyFollowsPrevious = false;

          if (
            !this._waitingForItem &&
            ((this._rate <= 0 && nextOffset <= containerSize) ||
              (this._rate > 0 && this._leftItemOffset >= 0))
          ) {
            this._waitingForItem = true; // if an item is appended immediately below, it would be considered immediately following
            // the previous if we haven't just changed direction.
            // This is useful when deciding whether to add a separator on the side that enters the
            // screen first or not

            this._nextItemImmediatelyFollowsPrevious = !justReversedRate;
            var nextItem;

            this._onItemRequired.some(function (cb) {
              return deferException(function () {
                nextItem = cb({
                  immediatelyFollowsPrevious:
                    _this5._nextItemImmediatelyFollowsPrevious,
                });
                return !!nextItem;
              });
            });

            if (nextItem) {
              // Note appendItem() will call _render() synchronously again
              this.appendItem(nextItem);
            }

            this._nextItemImmediatelyFollowsPrevious = false;
          }
        },
      },
    ]);

    return Marquee;
  })();

  var indexMap = function (list) {
    var map = {};
    list.forEach(function (each, i) {
      map[each] = map[each] || [];
      map[each].push(i);
    });
    return map;
  };

  var longestCommonSubstring = function (seq1, seq2) {
    var result = { startString1: 0, startString2: 0, length: 0 };
    var indexMapBefore = indexMap(seq1);
    var previousOverlap = [];
    seq2.forEach(function (eachAfter, indexAfter) {
      var overlapLength;
      var overlap = [];
      var indexesBefore = indexMapBefore[eachAfter] || [];
      indexesBefore.forEach(function (indexBefore) {
        overlapLength =
          ((indexBefore && previousOverlap[indexBefore - 1]) || 0) + 1;
        if (overlapLength > result.length) {
          result.length = overlapLength;
          result.startString1 = indexBefore - overlapLength + 1;
          result.startString2 = indexAfter - overlapLength + 1;
        }
        overlap[indexBefore] = overlapLength;
      });
      previousOverlap = overlap;
    });
    return result;
  };

  var longestCommonSubstring_1 = longestCommonSubstring;

  function loop(marquee) {
    var buildersIn =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var seperatorBuilder =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var lastIndex = -1;
    var builders = buildersIn.slice();

    var getNextBuilder = function getNextBuilder() {
      var offset =
        arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var nextIndex = (lastIndex + offset) % builders.length;
      return {
        builder: builders[nextIndex],
        index: nextIndex,
      };
    };

    var appendItem = function appendItem(immediatelyFollowsPrevious) {
      if (!builders.length || !marquee.isWaitingForItem()) {
        return;
      }

      var _getNextBuilder = getNextBuilder(),
        builder = _getNextBuilder.builder,
        index = _getNextBuilder.index;

      lastIndex = index;
      var $item = toDomEl(builder());

      if (immediatelyFollowsPrevious && seperatorBuilder) {
        var $seperator = toDomEl(seperatorBuilder());
        var $container = document.createElement('div');
        $seperator.style.display = 'inline';
        $item.style.display = 'inline';

        if (marquee.getRate() <= 0) {
          $container.appendChild($seperator);
          $container.appendChild($item);
        } else {
          $container.appendChild($item);
          $container.appendChild($seperator);
        }

        $item = $container;
      }

      marquee.appendItem($item);
    };

    marquee.onItemRequired(function (_ref) {
      var immediatelyFollowsPrevious = _ref.immediatelyFollowsPrevious;
      return appendItem(immediatelyFollowsPrevious);
    });
    appendItem();
    return {
      update: function update(newBuilders) {
        // try and start from somewhere that makes sense
        var calculateNewIndex = function calculateNewIndex() {
          // convert array of function references to array of ids
          var buildersStructure = builders.map(function (b, i) {
            var prevIndex = builders.indexOf(b); // if already seen builder, give it the same number

            return prevIndex < i ? prevIndex : i;
          });
          var newBuildersStructure = newBuilders.map(function (b, i) {
            // matching indexes where they exist, and -1 for all unknown
            return builders.indexOf(b);
          });

          var _longestSubstring = longestCommonSubstring_1(
              buildersStructure,
              newBuildersStructure
            ),
            startString1 = _longestSubstring.startString1,
            startString2 = _longestSubstring.startString2,
            length = _longestSubstring.length;

          if (lastIndex >= startString1 && lastIndex < startString1 + length) {
            // we are in the overlapping region
            return lastIndex + (startString2 - startString1);
          }

          return -1;
        };

        lastIndex = calculateNewIndex();
        builders = newBuilders.slice();
        appendItem(false);
      },
    };
  }

  exports.Marquee = Marquee;
  exports.loop = loop;

  Object.defineProperty(exports, '__esModule', { value: true });
});
